module.exports = __webpack_public_path__ + "static/img/course_support_3.f818f55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/course_support_3.png
// module id = ymG0
// module chunks = 1